import { ProgressType } from '@/features/v2/lib/wizard';
import OfferPage from '@/features/v2/summaryForms/components/offer/OfferPage';
import CheckDocuments from '@/features/v2/summaryForms/components/stages/CheckDocuments';
import Conflict from '@/features/v2/summaryForms/components/stages/Conflict';
import DownloadFiles from '@/features/v2/summaryForms/components/stages/DownloadFils';
import SignDocuments from '@/features/v2/summaryForms/components/stages/SignDocuments';
import ContactUs from '@/features/v2/vehicle-damage/components/thankYou/ContactUs';
import FinishedAll from '@/features/v2/vehicle-damage/components/thankYou/FinishedAll';
import FinishedStageI from '@/features/v2/vehicle-damage/components/thankYou/FinishedStageI';
import NotQualify from '@/features/v2/vehicle-damage/components/thankYou/NotQualify';

const createStage = (
  component: JSX.Element | null,
  progress: ProgressType | null
) => ({ component, progress });

export const createStagesVehicleDamage = () => {
  const offerPageComponent =
    import.meta.env.VITE_WITHOUT_SUMMARY === 'true' ? <OfferPage /> : null;
  const defaultProgress =
    import.meta.env.VITE_WITHOUT_SUMMARY === 'true' ? null : 'default';

  return {
    finished: createStage(<FinishedAll />, 'finished'),
    stage_II_finished: createStage(<FinishedAll />, 'finished'),
    not_qualified: createStage(<NotQualify />, 'not_qualified'),
    contact_us: createStage(<ContactUs />, 'contact_us'),
    stage_I: createStage(null, 'default'),
    stage_I_documents: createStage(null, 'default'),
    stage_I_finished: createStage(<FinishedStageI />, 'finished_stage_I'),
    stage_II: createStage(null, 'default'),
    stage_III: createStage(<OfferPage />, null),
    stage_III_finished: createStage(<OfferPage />, null),
    stage_III_conflict: createStage(<OfferPage />, null),
    stage_IV_complementary: createStage(offerPageComponent, defaultProgress),
    stage_IV: createStage(offerPageComponent, defaultProgress),
    stage_IV_finished: createStage(offerPageComponent, defaultProgress),
    stage_IV_conflict: createStage(
      import.meta.env.VITE_WITHOUT_SUMMARY === 'true' ? (
        <OfferPage />
      ) : (
        <Conflict />
      ),
      import.meta.env.VITE_WITHOUT_SUMMARY === 'true' ? null : 'conflict'
    ),
    stage_V: createStage(
      import.meta.env.VITE_WITHOUT_SUMMARY === 'true' ? (
        <OfferPage />
      ) : (
        <SignDocuments />
      ),
      defaultProgress
    ),
    stage_V_finished: createStage(
      import.meta.env.VITE_WITHOUT_SUMMARY === 'true' ? (
        <OfferPage />
      ) : (
        <CheckDocuments />
      ),
      defaultProgress
    ),
    stage_VI: createStage(
      import.meta.env.VITE_WITHOUT_SUMMARY === 'true' ? (
        <OfferPage />
      ) : (
        <DownloadFiles />
      ),
      import.meta.env.VITE_WITHOUT_SUMMARY === 'true' ? null : 'ready_doc'
    ),
  };
};
